import classnames from 'classnames';
import React from 'react';

import styles from 'iss/styles/Input.styl';
import {translate} from 'iss/strings';

export function BootstrapCheckbox({id, label, value, onChange, className, disabled = false}) {
  return <div className={classnames("checkbox", className)} id={id}>
    <label>
      <input type="checkbox" className={styles.largeCheckboxWithLabel} checked={!!value} onChange={onChange} disabled={disabled} />
      {translate(label)}
    </label>
  </div>;
}

export default BootstrapCheckbox;



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/bootstrap/Checkbox.jsx